import { render, staticRenderFns } from "./PageProductPublic.vue?vue&type=template&id=fc8de160&"
import script from "./PageProductPublic.vue?vue&type=script&lang=js&"
export * from "./PageProductPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc8de160')) {
      api.createRecord('fc8de160', component.options)
    } else {
      api.reload('fc8de160', component.options)
    }
    module.hot.accept("./PageProductPublic.vue?vue&type=template&id=fc8de160&", function () {
      api.rerender('fc8de160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageProductPublic.vue"
export default component.exports